import { Container, Typography } from '@pwskills/rachnaui';
import { IMasterclassDescription } from '@/interfaces/masterclassDescription';
import useMasterclassDescriptionStore from '@/store/MasterClassDescription/useMasterclasDescriptionStore';
import { useRouter } from 'next/router';
import MasterclassHeader from '../MasterclassHeader';

const WhyYouShouldEnrollSection = () => {
  const ColorForSlides = ['#EEF1FF', '#FEFBE7', '#FAEEE0', '#FDEFEF'];
  const masterclassDetails = useMasterclassDescriptionStore(
    (state: { masterclassDetails: IMasterclassDescription }) => state.masterclassDetails
  );
  const router = useRouter();

  const isDashboard = router.pathname.includes('/dashboard');
  const whoToEnrollMasterClass = masterclassDetails?.whoShouldEnroll || [];

  return (
    <div className={`${isDashboard ? '' : 'bg-blue-50'} w-full`}>
      <Container
        id="category-hero-section"
        className={`${
          isDashboard
            ? 'medium:!px-12 !pt-6 medium:!pb-6 medium:!pr-0 px-4 flex flex-col gap-14 large:!px-12'
            : '!py-6 medium:!p-8 large:!py-14 !px-4 large:!px-20 flex flex-col gap-14 medium:gap-8 large:gap-14'
        }`}
      >
        <div className={`flex flex-col gap-4 ${!isDashboard && 'justify-center'}items-center`}>
          <MasterclassHeader
            headerText="Who should enroll for the Masterclass?"
            // className={isDashboard ? 'text-left' : 'text-center'}
          />
          <Typography
            component="body-regular"
            variant="semi-bold"
            className={`${
              isDashboard
                ? 'text-left !text-[14px] text-gray-600 !leading-[22px]'
                : 'text-center !text-[16px] text-gray-900 !leading-[24px]'
            }
            }     large:w-[799px] `}
          >
            This masterclass provides valuable insights and practical knowledge, making it
            beneficial for participants at all levels of expertise.
          </Typography>
        </div>
        <div className="flex justify-center large:justify-start gap-4 min-[1024px]:!gap-4 small:flex-wrap medium:flex-nowrap">
          {whoToEnrollMasterClass?.map((item, index: number) => {
            return (
              <div
                className="bg-white px-3 pt-3 pb-5
                 rounded-lg shadow-medium overflow-hidden
                 relative group w-full medium:!w-fit !h-[296px]
                  min-[360px]:!w-full min-[744px]:!w-[332px]
                  min-[1024px]:!w-[272px]  min-[1280px]:!w-[262px]
                  min-[1440px]:!w-[302px] hover:cursor-pointer"
                key={item._id}
              >
                {/* <div className="relative w-full h-full overflow-hidden rounded-lg">
                  <img
                    src={item.image}
                    alt="enrollImage"
                    className="absolute object-[center_-50px] object-cover"
                  />
                </div> */}
                <div
                  style={{
                    backgroundImage: `url(${item.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                  className="w-full h-full rounded-lg"
                />

                <div
                  className="absolute bottom-0 p-4 left-0 w-full large:h-[48px] h-[136px] transition-all duration-500 ease-in-out group-hover:h-[136px] flex flex-col gap-2"
                  style={{ backgroundColor: 'white' }}
                >
                  {/*  for  desktop */}
                  <div
                    className="absolute hidden large:!block inset-0 h-[136px] transition-all duration-500 ease-in-out opacity-0 group-hover:opacity-100"
                    style={{
                      backgroundColor: ColorForSlides[index],
                    }}
                  />
                  {/*  for mobile and tab */}
                  <div
                    className="absolute inset-0 h-[136px] block large:!hidden "
                    style={{
                      backgroundColor: ColorForSlides[index],
                    }}
                  />
                  <Typography
                    component="body-regular"
                    variant="bold"
                    className="w-full rounded-b-lg z-[1]"
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    component="body-regular"
                    variant="regular"
                    className="w-full rounded-b-lg z-[1] !text-[16px] !leading-[24px] !text-gray-850 line-clamp-3"
                  >
                    {item.description}
                  </Typography>
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default WhyYouShouldEnrollSection;
